<template>

</template>

<script>
export default {
  name: "MoveInMoveOutPage"
}
</script>


